import type { DeliveryMode } from './navigator-results.types';

/** Short chip copy — reused vocabulary (map-profile-coverage-from-specialties.ts). */
export const DELIVERY_MODE_LABEL: Record<DeliveryMode, string> = {
  IN_HOME: 'In-home',
  VIRTUAL: 'Virtual',
  IN_OFFICE: 'In-office',
};

/** Tooltip copy — what the mode means for the care seeker, not the enum name. */
export const DELIVERY_MODE_HINT: Record<DeliveryMode, string> = {
  IN_HOME: 'Comes to you — visits happen at your home.',
  VIRTUAL: 'Meets by video or phone, wherever you are.',
  IN_OFFICE: 'You go to them — visits happen at their office.',
};
